module.exports = __webpack_public_path__ + "/hashedassets-launcher/logo.f2f176216327b1fc1c6f749983b00b8f.svg";